"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControllerImpl = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-dupe-class-members */
var immer_1 = require("immer");
var ControllerImpl = /** @class */ (function () {
    function ControllerImpl(locator) {
        this.onChanges = {};
        this.getters = {};
        this.setters = {};
        this.changeListeners = [];
        this.memoisedSnapshots = {};
        this.memoisedControllers = {};
        this.locator = locator;
    }
    ControllerImpl.prototype.snapshot = function (nameOrIndex, index) {
        var _this = this;
        if (index !== undefined) {
            return this.controller(nameOrIndex).snapshot(index);
        }
        var result;
        if (typeof nameOrIndex === 'number') {
            var onChange = function (newValue) {
                var parentNewValue = (0, immer_1.produce)(_this.value, function (draft) {
                    draft[nameOrIndex] = newValue;
                });
                _this.setValue(parentNewValue);
            };
            var value = this.value !== undefined ? this.value[nameOrIndex] : undefined;
            result = {
                setValue: onChange,
                value: (0, immer_1.produce)(value, function (draft) { }),
            };
        }
        else if (nameOrIndex === undefined || nameOrIndex === 'this') {
            result = {
                setValue: function (newValue) { return _this.setValue(newValue); },
                value: (0, immer_1.produce)(this.value, function (draft) { }),
            };
        }
        else {
            var onChange = this.propOnChange(nameOrIndex);
            var value = this.value !== undefined ? this.value[nameOrIndex] : undefined;
            var getter = this.getters[nameOrIndex];
            if (getter) {
                value = getter(value);
            }
            result = {
                setValue: onChange,
                value: (0, immer_1.produce)(value, function (draft) { }),
            };
        }
        /* If the snapshot value hasn't changed, we return the memoised snapshot */
        var memoisedSnapshot = this.memoisedSnapshots["" + nameOrIndex];
        if (memoisedSnapshot && memoisedSnapshot.value === result.value) {
            return memoisedSnapshot;
        }
        else {
            this.memoisedSnapshots["" + nameOrIndex] = result;
            return result;
        }
    };
    ControllerImpl.prototype.getter = function (name, func) {
        this.getters[name] = func;
    };
    ControllerImpl.prototype.setter = function (name, func) {
        this.setters[name] = func;
        delete this.onChanges[name];
    };
    ControllerImpl.prototype.addChangeListener = function (listener) {
        this.changeListeners.push(listener);
    };
    ControllerImpl.prototype.removeChangeListener = function (listener) {
        var index = this.changeListeners.indexOf(listener);
        if (index !== -1) {
            this.changeListeners.splice(index, 1);
        }
    };
    ControllerImpl.prototype.removeAllChangeListeners = function () {
        this.changeListeners = [];
    };
    ControllerImpl.prototype.controller = function (nameOrIndex, index) {
        var _this = this;
        if (index !== undefined) {
            return this.controller(nameOrIndex).controller(index);
        }
        else if (nameOrIndex === 'this') {
            return this;
        }
        var memoisedController = this.memoisedControllers["" + nameOrIndex];
        if (memoisedController) {
            return memoisedController;
        }
        var result;
        if (typeof nameOrIndex === 'number') {
            result = new ControllerImpl(function () { return _this.snapshot(nameOrIndex); });
        }
        else {
            result = new ControllerImpl(function () { return _this.snapshot(nameOrIndex); });
        }
        this.memoisedControllers["" + nameOrIndex] = result;
        return result;
    };
    Object.defineProperty(ControllerImpl.prototype, "value", {
        get: function () {
            return this.locator().value;
        },
        enumerable: false,
        configurable: true
    });
    ControllerImpl.prototype.setValue = function (value) {
        var oldValue = this.locator().value;
        this.locator().setValue(value);
        for (var _i = 0, _a = this.changeListeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(value, oldValue);
        }
    };
    ControllerImpl.prototype.propOnChange = function (name) {
        var _this = this;
        var PROPERTY = this.onChanges[name];
        if (PROPERTY) {
            return PROPERTY;
        }
        var func = function (subValue) {
            var _a;
            var value = _this.value;
            var newValue = value !== undefined ?
                (0, immer_1.produce)(value, function (draft) {
                    draft[name] = subValue;
                })
                : (_a = {},
                    _a[name] = subValue,
                    _a);
            _this.setValue(newValue);
        };
        var setter = this.setters[name];
        if (setter) {
            var existingNewFunc_1 = func;
            var newFunc = function (subValue) {
                var subValue2 = setter(subValue);
                existingNewFunc_1(subValue2);
            };
            func = newFunc;
        }
        this.onChanges[name] = func;
        return func;
    };
    return ControllerImpl;
}());
exports.ControllerImpl = ControllerImpl;
